import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { NotificationService } from '../../_services/notification.service';
import { PaymentService } from '../../modules/payment/payment.service';
import { LocalService } from '../../_services/local.service';
import { ExportExcelService } from '../../_services/export-excel.service';
import { FormBuilder } from '@angular/forms';
import { PaymentAfterLogout } from '../../modules/payment/payment-model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  stripe: Stripe = null;
  public paymentCards:any[] = [];
  public freePaymentModels:any=null;
  public paidPaymentModels:any=null;
  public paid2PaymentModels:any=null;
  public openPaymentDilog = false;
  public openDilogConfirmation = false;
  public selectedModel:any=null;
  public selectedMode:any=null;
  public paymentCardType:any=null;
  public waitDialog = false;
  elements: any;
  card: any;
  cardExpiry: any;
  cardCvc: any;
  public cardHolderName: string = '';
  public isFormValid: boolean = false;
  private cardComplete: boolean = false;
  private expiryComplete: boolean = false;
  private cvcComplete: boolean = false;
  public paymentModel: PaymentAfterLogout = new PaymentAfterLogout();
  client: any;
  user:any;
  constructor(public _notificationService: NotificationService,
    public _paymentService: PaymentService,
    public _localService: LocalService,
    private _exportToExcelService: ExportExcelService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private zone: NgZone,
    private router: Router) { }

    async ngOnInit() {
debugger
    this.client = this._localService.get("com");
    this.user = this._localService.get("ussr");
    this.getPaymentModels();

    if (this.card) this.card.unmount();
  if (this.cardExpiry) this.cardExpiry.unmount();
  if (this.cardCvc) this.cardCvc.unmount();
  }

  public getPaymentModels() {
    this._paymentService.getPricingModelsAfterLogout().subscribe((res: any) => {
      debugger;
      if (res) {
        console.log(res);
        debugger
        this.freePaymentModels = res.result[0];
        this.paidPaymentModels = res.result[1];
        this.paid2PaymentModels = res.result[2];
      }
    }, err => {
      debugger;

      this._notificationService.notify("danger", err.msg);

    });
  }

  public close(status) {

    this.openPaymentDilog = false;
  }
  public closeCat(status) {

    this.openDilogConfirmation = false;
  
  }
  public SelectModeStandard(mode){
    debugger
    this.selectedMode = mode;
  }
  public SelectModeBasic(mode){
    debugger
    this.selectedMode = mode;
  }
  public async OpenPaymentDialog(model){
    debugger
    if(this.selectedMode == null || this.selectedMode == "" || this.selectedMode == undefined){
      this._notificationService.notify("danger", "Please select subscription plan.");
      return;
    }
    this.selectedModel = model;
    this.openPaymentDilog = true;

    this.cdr.detectChanges(); // Ensure Angular knows about the DOM update
     //this.stripe = await loadStripe('pk_test_51Jw7gfK5kl62KQXy6ICaLPXyEJIUwKpDlZc0ifaCM23WLjjoP8Uy9go9TfCuVkgZ5Fhu63GwF4Ucf7VuxCdYIY1T0053BzazlA');
     this.stripe = await loadStripe('pk_live_51Jw7gfK5kl62KQXyXF8YKgaJB1XmqiQeUmQKgPwUz0KTTmF9X13o16rSdI9vZRON3GSRy0IJqDOwPH6mwGl9sR6v00SMHPPrBd');

    if (!this.stripe) {
      console.error('Stripe has not been loaded correctly.');
      this._notificationService.notify("danger", 'Stripe has not been loaded correctly.');
      return;
    }

    if (this.card) this.card.unmount();
    if (this.cardExpiry) this.cardExpiry.unmount();
    if (this.cardCvc) this.cardCvc.unmount();

    this.elements = this.stripe.elements();
debugger
      this.card = this.elements.create('cardNumber', { style: { base: { fontSize: '16px', color: '#32325d' } } });
      this.cardExpiry = this.elements.create('cardExpiry', { style: { base: { fontSize: '16px', color: '#32325d' } } });
      this.cardCvc = this.elements.create('cardCvc', { style: { base: { fontSize: '16px', color: '#32325d' } } });

      setTimeout(() => {
       if (document.getElementById('card-element') && document.getElementById('expiry-element') && document.getElementById('cvc-element')) {
         this.card.mount('#card-element');
         this.cardExpiry.mount('#expiry-element');
         this.cardCvc.mount('#cvc-element');
       } else {
         console.error('Stripe element containers not found in DOM.');
       }
     }, 100);

debugger
     this.card.on('change', (event) => this.handleCardChange(event, 'card'));
     this.cardExpiry.on('change', (event) => this.handleCardChange(event, 'expiry'));
     this.cardCvc.on('change', (event) => this.handleCardChange(event, 'cvc'));
  }

  handleCardChange(event: any, elementType: string) {
    // Update the complete status for each element
    if (elementType === 'card') {
      this.cardComplete = event.complete;
    } else if (elementType === 'expiry') {
      this.expiryComplete = event.complete;
    } else if (elementType === 'cvc') {
      this.cvcComplete = event.complete;
    }
  
    this.updateFormValidity();
  }
  
  // Update form validity based on all fields
  updateFormValidity() {
    const isStripeElementsComplete = this.cardComplete && this.expiryComplete && this.cvcComplete;
    this.isFormValid = !!this.cardHolderName && isStripeElementsComplete;
  }

  public PaymentConfirm(){
    this.openDilogConfirmation = true;
  }
 async ConfirmPayment(){
  debugger
  if (!this.stripe || !this.card || !document.getElementById('card-element')) {
    this._notificationService.notify("danger", 'Stripe or Card Element is not initialized or not mounted');
    return;
  }
  this.waitDialog = true;

  const cardHolderName = (document.getElementById('card-holder-name') as HTMLInputElement).value;
  this.zone.runOutsideAngular(async () => {
    debugger
    try {
      console.log('Element type:', this.card._componentName); 
        const { token, error } = await this.stripe.createToken(this.card, {
          name: cardHolderName
        });

      if (error) {
        this.zone.run(() => {
          this._notificationService.notify("danger", error.message);
          this.openDilogConfirmation = false;
          this.openPaymentDilog = false;
        });
        return;
      }
debugger
      if (token) {
        this.paymentModel.Token = token.id;
        this.paymentModel.CardHolderName = cardHolderName;
        this.paymentModel.ClientId = this.client.Id;
        this.paymentModel.Last4Digits = token.card.last4;
        this.paymentModel.PricingModelId = this.selectedModel;
        this.paymentModel.PricingMode = this.selectedMode;
        this.paymentModel.PaymentCardType = this.paymentCardType;
        this.paymentModel.UserId = this.user.Id;
        this._paymentService.addPaymentAfterLogout(this.paymentModel).subscribe((res: any) => {
          this.openPaymentDilog = false;
          this.openDilogConfirmation = false;
          this.router.navigate(['/account/login']);
          this.paymentModel = new PaymentAfterLogout();
        }, err => {
          this._notificationService.notify("danger", err.error);
          this.openDilogConfirmation = false;
          this.openPaymentDilog = false;
        });
      }
    } catch (err) {
      console.error('Unexpected error during token creation:', err);
      this.openDilogConfirmation = false;
      this.openPaymentDilog = false;
      this.paymentModel = new PaymentAfterLogout();
    }
  });
 }

  ngOnDestroy() {
    if (this.card) this.card.unmount();
    if (this.cardExpiry) this.cardExpiry.unmount();
    if (this.cardCvc) this.cardCvc.unmount();
  }

}
